import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../../../environments/environment';
import { SurveyAuthService } from '../../../../shared/survey-auth.service';
import { Page } from '../models/page';
import { Survey } from '../models/survey';

@Injectable()
export class PageService {
  constructor(private http: HttpClient, private auth: SurveyAuthService) {}

  insertPage(
    survey: Survey,
    page: Page,
    reference_page: Page
  ): Observable<any> {
    let post_url = `${environment.surveyApiHost}/api/v1/surveys/${survey.id}/pages/`;
    if (reference_page != null) {
      post_url = post_url + `?ref_page_id=${reference_page.id}`;
    }
    console.log('POST ' + post_url);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);

    return this.http
      .post(post_url, page, { headers: headers })
      .map(this.processPostPutResponse)
      .catch(this.handleError);
  }

  updatePage(page: Page): Observable<any> {
    const put_url = `${environment.surveyApiHost}/api/v1/surveys/${
      page.getSurvey().id
    }/pages/${page.id}/`;
    console.log('PUT ' + put_url);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);

    console.log('page: ', page.toJSON());
    return this.http
      .put(put_url, page.toJSON(), { headers: headers })
      .catch(this.handleError);
  }

  deletePage(page: Page): Observable<any> {
    const delete_url = `${environment.surveyApiHost}/api/v1/surveys/${
      page.getSurvey().id
    }/pages/${page.id}/`;
    console.log('DELETE ' + delete_url);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);

    return this.http
      .delete(delete_url, { headers: headers })
      .catch(this.handleError);
  }

  movePage(page: Page, new_order: number): Observable<any> {
    let get_url = `${environment.surveyApiHost}/api/v1/surveys/${
      page.getSurvey().id
    }/pages/${page.id}/move`;
    if (new_order != null) {
      get_url = get_url + `?new_order=${new_order}`;
    }
    console.log('GET ' + get_url);
    let headers = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    const tokenStr = `Token ${this.auth.token()}`;
    headers = headers.append('Authorization', tokenStr);

    return this.http.get(get_url, { headers: headers }).catch(this.handleError);
  }

  private processPostPutResponse(res: HttpResponse<any>): Page {
    console.log('processPostResponse: res: ', res);
    const body = res.body.json();
    console.log('processResponse: body: ', body);
    const page: Page = Object.create(Page.prototype);
    const obj = Object.assign(page, body, {});
    return obj || {};
  }

  private handleError(error: HttpResponse<any> | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof HttpResponse) {
      const body = error.body.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }
}
